import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=b10a2c28&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"
import style0 from "./Landing.vue?vue&type=style&index=0&id=b10a2c28&prod&lang=scss&scoped=true"
import style1 from "./Landing.vue?vue&type=style&index=1&id=b10a2c28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10a2c28",
  null
  
)

export default component.exports